import { RootState } from "../types";
import {
  UserInformationReducer,
  UserReducer,
  UserSettingsReducer,
} from "./types";

export const getUserSlice = (state: RootState): UserReducer => state.user;

export const getUserSettings = (state: RootState): UserSettingsReducer =>
  getUserSlice(state).settings;

export const getDefaultMaxPageRowCount = (state: RootState): number | null =>
  getUserSettings(state).defaultMaxPageRowCount;

export const getUserInformation = (state: RootState): UserInformationReducer =>
  getUserSlice(state).information;

export const getIsUserLoading = (state: RootState) =>
  getUserSlice(state).isLoading;
